"use no memo";

import { createContext } from 'react';

export type ApplePayContextProps = {
  hasApplePayActiveCard: boolean;
  isApplePayLoading: boolean;
};

const ApplePayContext = createContext<ApplePayContextProps>({
  hasApplePayActiveCard: false,
  isApplePayLoading: false,
});

export default ApplePayContext;
